import { Suspense, lazy } from 'react';
import { Route } from 'react-router-dom';
import PRIVILEGES from '../constants/privileges';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import { RBACRoute } from './RBACRoute';

const CompanyDetails = lazy(() => import('../modules/company-details'));
const CompanyDetailsSection = lazy(
  () => import('../modules/company-details/pages/CompanyDetailsSection')
);

const CompanyDetailsRoutes = (
  <>
    <Route
      path="company-details"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <CompanyDetails />
        </Suspense>
      }
    >
      <Route
        path=""
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.COMPANY_DETAILS_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <CompanyDetailsSection />
            </Suspense>
          </RBACRoute>
        }
      />
      {/* <Route
        path="manage-approvals"
        element={
          <RBACRoute privileges={[PRIVILEGES.COMMON.COMPANY_DETAILS_VIEW]}>
            <Suspense fallback={<SkeletonPage />}>
              <ManageApprovalsView />
            </Suspense>
          </RBACRoute>
        }
      /> */}
    </Route>
  </>
);

export default CompanyDetailsRoutes;
